import moment from "moment";

export const BIWEEKLY_MAPPING = "/home/WeeklySprint";
export const START_DATE_WEEKLY_FORMAT = moment(new Date()).startOf("week").format("YYYY-MM-DD");
export const END_DATE_WEEKLY_FORMAT = moment(new Date()).endOf("week").format("YYYY-MM-DD");